export default {
    install(Vue, options) {
      Vue.prototype.$validate = (code, payload) => {

        console.error(code);


    
        // let sTranslate = code || '';
        // let sUserLang = JSON.parse(localStorage.getItem('user')).PCLAN || 'F';
      
        // let aLangConvert = {
        //   'F': 'fr_FR',
        //   'A': 'en_EN',
        //   'D': 'de_DE',
        //   'E': 'es_ES',
        //   'I': 'it_IT'
        // };
  
        // let lang = require(`@/lang/${aLangConvert[sUserLang]}.js`);
  
        // if (lang.default[sTranslate] === undefined) {
        //   lang.default[sTranslate] = '';
        // }
        
        // return lang.default[sTranslate];
      };
      Vue.prototype.$upper = (e) => {
        console.error(e.target.value);
          return e.target.value = e.target.value.toUpperCase()
      };
    }
  };
  